export const ShareEmail = ({
  to = "",
  subject = "",
  body = "",
  preferGmail = false
}) => {
  const encodedSubject = encodeURIComponent(subject);
  // Normalize newlines for better rendering in mail clients
  const encodedBody = encodeURIComponent(body.replace(/\n/g, "\r\n"));

  const isMobile = /Mobi|Android/i.test(navigator.userAgent);

  let emailUrl;

  if (preferGmail) {
    // Open Gmail compose in browser
    emailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${encodedSubject}&body=${encodedBody}`;
  } else {
    // Try default email client (Outlook, Mail, Gmail if set)
    emailUrl = `mailto:${to}?subject=${encodedSubject}&body=${encodedBody}`;
  }

  if (isMobile) {
    // Mobile: open directly
    window.location.href = emailUrl;
  } else {
    // Desktop: use hidden anchor to avoid blank tab
    const a = document.createElement("a");
    a.href = emailUrl;
    a.style.display = "none";
    a.target = "_self";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Optional fallback to Gmail
    if (!preferGmail) {
      setTimeout(() => {
        const wantsFallback = window.confirm(
          "It looks like your default email client may not be configured. Open in Gmail instead?"
        );
        if (wantsFallback) {
          window.open(
            `https://mail.google.com/mail/?view=cm&fs=1&to=${to}&su=${encodedSubject}&body=${encodedBody}`,
            "_blank"
          );
        }
      }, 1200);
    }
  }
};
